// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RoundIconButton Styles */

.scl--web-component-round-icon-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: linear-gradient(
    110.72deg,
    rgba(255, 255, 255, 0.2) -2.91%,
    rgba(255, 255, 255, 0) -2.9%,
    rgba(255, 255, 255, 0) 17.95%,
    rgba(255, 255, 255, 0.06) 19.42%,
    rgba(255, 255, 255, 0.06) 34.01%,
    rgba(255, 255, 255, 0) 38.67%,
    rgba(255, 255, 255, 0) 50.86%,
    rgba(255, 255, 255, 0.06) 53.07%,
    rgba(255, 255, 255, 0.06) 66.11%,
    rgba(255, 255, 255, 0) 72.21%
  ),
  rgba(214, 214, 214, 0.1);
  border: 2px solid #FFFFFF;
  box-shadow: inset 0px -1px 18px #FFFFFF;
  backdrop-filter: blur(9px);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Icon with rotation animation */
.scl--web-component-round-icon-button-icon {
  width: 30px;
  height: 30px;
  flex: none;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.scl--web-component-round-icon-button-icon.rotated {
  transform: rotate(45deg);
}

/* Disabled state */
.scl--web-component-round-icon-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Wrapper for button + options bar */
.scl--web-component-round-icon-button-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  position: relative;
}

/* Options Bar - simple fade transition */
.scl--web-component-round-icon-button-options-bar {
  box-sizing: border-box;
  max-width: 710px;
  height: 75px;
  background: linear-gradient(146.22deg, rgba(219, 224, 231, 0.1) 9.7%, rgba(248, 251, 255, 0.1) 86.02%);
  backdrop-filter: blur(41.84px);
  box-shadow: 
    0px 644px 258.06px 0px rgba(0, 0, 0, 0.01),
    0px 1006.69px 281.31px 0px rgba(0, 0, 0, 0);
  border-radius: 200px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  right: 110px;
  top: 90px;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

/* Gradient border using pseudo-element */
.scl--web-component-round-icon-button-options-bar::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 200px;
  padding: 1px;
  background: linear-gradient(180deg, #F2F2F2 0%, #818181 41.42%, #FFFFFF 100%);
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.scl--web-component-round-icon-button-options-bar.visible {
  opacity: 1;
  pointer-events: auto;
}

/* Inner flex container for options items */
.scl--web-component-round-icon-button-options-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

/* Individual option item pill */
.scl--web-component-round-icon-button-option-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
  min-width: 116px;
  min-height: 46px;
  background: transparent;
  border-radius: 50px;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
  flex: none;
}

.scl--web-component-round-icon-button-option-item:hover {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0px 644px 258.065px rgba(0, 0, 0, 0.01);
}

/* Icon container with fixed size */
.scl--web-component-round-icon-button-option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 28px;
}

/* Icon inside option item with opacity */
.scl--web-component-round-icon-button-option-icon svg,
.scl--web-component-round-icon-button-option-icon img {
  opacity: 0.8;
  transition: opacity 0.2s ease;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.scl--web-component-round-icon-button-option-item:hover svg,
.scl--web-component-round-icon-button-option-item:hover img {
  opacity: 1;
}

.scl--web-component-round-icon-button-option-label {
  font-family: var(--primary-font);
  font-size: 12px;
  color: #FFFFFF;
  margin-top: 4px;
  text-align: center;
}

/* ==========================================
   Icon + Label variant (has-labels)
   ========================================== */

/* Options bar when options have icon + label */
.scl--web-component-round-icon-button-options-bar.has-labels {
  max-width: 710px;
  height: 69px;
}

/* Inner container for icon+label variant */
.scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {
  padding: 0 10px;
}

/* Option item pill with label */
.scl--web-component-round-icon-button-option-item.with-label {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  min-width: 116px;
  max-height: 50px;

  border-radius: 50px;
}

/* Horizontal icon + label row wrapper */
.scl--web-component-round-icon-button-option-icon-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 5px;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.scl--web-component-round-icon-button-option-item.with-label:hover .scl--web-component-round-icon-button-option-icon-label {
  opacity: 1;
}

/* Icon size in icon+label variant */
.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon img{
  width: 100%;
  height: 100%;
}

/* Label in icon+label variant */
.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 50px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  margin-top: 0;
  white-space: nowrap;
}

/* ==========================================
   Multi-row variant
   ========================================== */

/* Options bar with multiple rows */
.scl--web-component-round-icon-button-options-bar.multi-row {
  height: auto;
  border-radius: 30px;
}
.scl--web-component-round-icon-button-options-bar.multi-row .scl--web-component-round-icon-button-options-inner {
  padding: 0 8px;
}

.scl--web-component-round-icon-button-options-bar.multi-row::before {
  border-radius: 30px;
}

/* Vertical column container for rows */
.scl--web-component-round-icon-button-options-multi-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}

/* Row inside multi-row uses same inner styles */
.scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {
  height: auto;
  padding: 5px 10px;
}

/* Horizontal divider line between rows */
.scl--web-component-round-icon-button-options-divider {
  width: 90%;
  height: 1px;
  margin: 5px;
  background: rgba(255, 255, 255, 0.15);
  flex: none;
}

/* ==========================================
   Responsive Design - 440px
   ========================================== */

@media screen and (max-width: 500px) {
  /* Options Bar - Icon Only variant (min 3 items per row) */
  .scl--web-component-round-icon-button-options-bar {
    width: 370px;
    max-width: 370px;
    height: auto;
    padding: 8px 0px;
    gap: 5px;
    border-radius: 30px;
    right: 50%;
    transform: translateX(50%);
    top: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .scl--web-component-round-icon-button-options-bar::before {
    border-radius: 30px;
  }

  /* Inner container - allows 3 items per row for icon only */
  .scl--web-component-round-icon-button-options-inner {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 3px;
    gap: 10px 0px;
    width: 360px;
  }
  /* Individual option item pill */
.scl--web-component-round-icon-button-option-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  min-width: 110px;
  min-height: 50px;
  background: transparent;
  padding: 20px;
  border-radius: 50px;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
  flex: none;
}

  /* Options rows wrapper - flatten for mobile */
  .scl--web-component-round-icon-button-options-multi-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 370px;
    padding: 0;
    gap: 10px 0px;
  }

  /* Make inner containers display:contents to flatten structure */
  .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {
    display: contents;
  }

  /* Hide dividers on mobile */
  .scl--web-component-round-icon-button-options-divider {
    display: none;
  }

  /* Individual option item pill - icon only (116px = 3 per 350px row) */
  .scl--web-component-round-icon-button-option-item { 
    padding: 10px 15px;
    max-width: 116px;
    min-height: 46px;
    gap: 24px;
    border-radius: 50px;
    box-sizing: border-box;
    flex: 0 0 116px;
  }

  /* Icon container */
  .scl--web-component-round-icon-button-option-icon {
    width: 43px;
    height: 27px;
  }

  /* ==========================================
     Icon + Label variant - 440px (min 2 items per row)
     ========================================== */

  .scl--web-component-round-icon-button-options-bar.has-labels {
    width: 370px;
    max-width: 370px;
    height: auto;
    padding: 10px 10px;
    gap: 5px;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* Inner container - allows 2 items per row for icon+label */
  .scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 10px 5px;
    width: 370px;
  }

  /* Option item pill with label (165px = 2 per 340px row with 5px gap) */
  .scl--web-component-round-icon-button-option-item.with-label {
    padding: 12px 15px;
    min-width: 165px;
    max-width: 165px;
    max-height: 50px;
    border-radius: 50px;
    box-sizing: border-box;
    flex: 0 0 165px;
  }

  /* Icon + label row wrapper - 440px */
  .scl--web-component-round-icon-button-option-icon-label {
    gap: 9px;
  }

  /* Icon size in icon+label variant - 440px */
  .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {
    width: 26px;
    height: 26px;
  }

  /* Label in icon+label variant - 440px */
  .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {
    font-size: 16px;
    line-height: 16px;
    white-space: nowrap;
  }

  /* ==========================================
     Multi-row variant - 440px
     ========================================== */

  .scl--web-component-round-icon-button-options-bar.multi-row {
    width: 370px;
    max-width: 370px;
    height: auto;
    border-radius: 30px;
  }

  /* Icon + Label multi-row */
  .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 350px;
    gap: 10px 5px;
  }

  /* Flatten inner containers for has-labels multi-row (needs higher specificity) */
  .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {
    display: contents;
  }
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/button/round-button/css/roundIconButton.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV;;;;;;;;;;;;;0BAawB;EACxB,yBAAyB;EACzB,uCAAuC;EACvC,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,MAAM;EACN,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sGAAsG;EACtG,8BAA8B;EAC9B;;+CAE6C;EAC7C,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,YAAY;EACZ,6EAA6E;EAC7E;;6BAE2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sDAAsD;EACtD,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;AACzC;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;+CAE+C;;AAE/C,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;+CAE+C;;AAE/C,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;+CAE+C;;AAE/C;EACE,0DAA0D;EAC1D;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;EACd;EACA,gCAAgC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sDAAsD;EACtD,UAAU;AACZ;;EAEE,8CAA8C;EAC9C;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,aAAa;EACf;;EAEA,gEAAgE;EAChE;IACE,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;EACf;;EAEA,sEAAsE;EACtE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;iDAE+C;;EAE/C;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,4DAA4D;EAC5D;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA,uEAAuE;EACvE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,QAAQ;EACV;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;iDAE+C;;EAE/C;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA,iFAAiF;EACjF;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* RoundIconButton Styles */\n\n.scl--web-component-round-icon-button {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background: linear-gradient(\n    110.72deg,\n    rgba(255, 255, 255, 0.2) -2.91%,\n    rgba(255, 255, 255, 0) -2.9%,\n    rgba(255, 255, 255, 0) 17.95%,\n    rgba(255, 255, 255, 0.06) 19.42%,\n    rgba(255, 255, 255, 0.06) 34.01%,\n    rgba(255, 255, 255, 0) 38.67%,\n    rgba(255, 255, 255, 0) 50.86%,\n    rgba(255, 255, 255, 0.06) 53.07%,\n    rgba(255, 255, 255, 0.06) 66.11%,\n    rgba(255, 255, 255, 0) 72.21%\n  ),\n  rgba(214, 214, 214, 0.1);\n  border: 2px solid #FFFFFF;\n  box-shadow: inset 0px -1px 18px #FFFFFF;\n  backdrop-filter: blur(9px);\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Icon with rotation animation */\n.scl--web-component-round-icon-button-icon {\n  width: 30px;\n  height: 30px;\n  flex: none;\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.scl--web-component-round-icon-button-icon.rotated {\n  transform: rotate(45deg);\n}\n\n/* Disabled state */\n.scl--web-component-round-icon-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Wrapper for button + options bar */\n.scl--web-component-round-icon-button-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  position: relative;\n}\n\n/* Options Bar - simple fade transition */\n.scl--web-component-round-icon-button-options-bar {\n  box-sizing: border-box;\n  max-width: 710px;\n  height: 75px;\n  background: linear-gradient(146.22deg, rgba(219, 224, 231, 0.1) 9.7%, rgba(248, 251, 255, 0.1) 86.02%);\n  backdrop-filter: blur(41.84px);\n  box-shadow: \n    0px 644px 258.06px 0px rgba(0, 0, 0, 0.01),\n    0px 1006.69px 281.31px 0px rgba(0, 0, 0, 0);\n  border-radius: 200px;\n  overflow: hidden;\n  opacity: 0;\n  position: absolute;\n  right: 110px;\n  top: 90px;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n/* Gradient border using pseudo-element */\n.scl--web-component-round-icon-button-options-bar::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 200px;\n  padding: 1px;\n  background: linear-gradient(180deg, #F2F2F2 0%, #818181 41.42%, #FFFFFF 100%);\n  -webkit-mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  pointer-events: none;\n}\n\n.scl--web-component-round-icon-button-options-bar.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* Inner flex container for options items */\n.scl--web-component-round-icon-button-options-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n\n/* Individual option item pill */\n.scl--web-component-round-icon-button-option-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 25px;\n  min-width: 116px;\n  min-height: 46px;\n  background: transparent;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n  flex: none;\n}\n\n.scl--web-component-round-icon-button-option-item:hover {\n  background: rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 644px 258.065px rgba(0, 0, 0, 0.01);\n}\n\n/* Icon container with fixed size */\n.scl--web-component-round-icon-button-option-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 65px;\n  height: 28px;\n}\n\n/* Icon inside option item with opacity */\n.scl--web-component-round-icon-button-option-icon svg,\n.scl--web-component-round-icon-button-option-icon img {\n  opacity: 0.8;\n  transition: opacity 0.2s ease;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--web-component-round-icon-button-option-item:hover svg,\n.scl--web-component-round-icon-button-option-item:hover img {\n  opacity: 1;\n}\n\n.scl--web-component-round-icon-button-option-label {\n  font-family: var(--primary-font);\n  font-size: 12px;\n  color: #FFFFFF;\n  margin-top: 4px;\n  text-align: center;\n}\n\n/* ==========================================\n   Icon + Label variant (has-labels)\n   ========================================== */\n\n/* Options bar when options have icon + label */\n.scl--web-component-round-icon-button-options-bar.has-labels {\n  max-width: 710px;\n  height: 69px;\n}\n\n/* Inner container for icon+label variant */\n.scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {\n  padding: 0 10px;\n}\n\n/* Option item pill with label */\n.scl--web-component-round-icon-button-option-item.with-label {\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 25px;\n  min-width: 116px;\n  max-height: 50px;\n\n  border-radius: 50px;\n}\n\n/* Horizontal icon + label row wrapper */\n.scl--web-component-round-icon-button-option-icon-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  gap: 5px;\n  opacity: 0.8;\n  transition: opacity 0.2s ease;\n}\n\n.scl--web-component-round-icon-button-option-item.with-label:hover .scl--web-component-round-icon-button-option-icon-label {\n  opacity: 1;\n}\n\n/* Icon size in icon+label variant */\n.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {\n  width: 31px;\n  height: 31px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon img{\n  width: 100%;\n  height: 100%;\n}\n\n/* Label in icon+label variant */\n.scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 50px;\n  display: flex;\n  align-items: center;\n  color: #FFFFFF;\n  margin-top: 0;\n  white-space: nowrap;\n}\n\n/* ==========================================\n   Multi-row variant\n   ========================================== */\n\n/* Options bar with multiple rows */\n.scl--web-component-round-icon-button-options-bar.multi-row {\n  height: auto;\n  border-radius: 30px;\n}\n.scl--web-component-round-icon-button-options-bar.multi-row .scl--web-component-round-icon-button-options-inner {\n  padding: 0 8px;\n}\n\n.scl--web-component-round-icon-button-options-bar.multi-row::before {\n  border-radius: 30px;\n}\n\n/* Vertical column container for rows */\n.scl--web-component-round-icon-button-options-multi-row {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  box-sizing: border-box;\n}\n\n/* Row inside multi-row uses same inner styles */\n.scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {\n  height: auto;\n  padding: 5px 10px;\n}\n\n/* Horizontal divider line between rows */\n.scl--web-component-round-icon-button-options-divider {\n  width: 90%;\n  height: 1px;\n  margin: 5px;\n  background: rgba(255, 255, 255, 0.15);\n  flex: none;\n}\n\n/* ==========================================\n   Responsive Design - 440px\n   ========================================== */\n\n@media screen and (max-width: 500px) {\n  /* Options Bar - Icon Only variant (min 3 items per row) */\n  .scl--web-component-round-icon-button-options-bar {\n    width: 370px;\n    max-width: 370px;\n    height: auto;\n    padding: 8px 0px;\n    gap: 5px;\n    border-radius: 30px;\n    right: 50%;\n    transform: translateX(50%);\n    top: 80px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .scl--web-component-round-icon-button-options-bar::before {\n    border-radius: 30px;\n  }\n\n  /* Inner container - allows 3 items per row for icon only */\n  .scl--web-component-round-icon-button-options-inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 3px;\n    gap: 10px 0px;\n    width: 360px;\n  }\n  /* Individual option item pill */\n.scl--web-component-round-icon-button-option-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  min-width: 110px;\n  min-height: 50px;\n  background: transparent;\n  padding: 20px;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n  flex: none;\n}\n\n  /* Options rows wrapper - flatten for mobile */\n  .scl--web-component-round-icon-button-options-multi-row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 370px;\n    padding: 0;\n    gap: 10px 0px;\n  }\n\n  /* Make inner containers display:contents to flatten structure */\n  .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {\n    display: contents;\n  }\n\n  /* Hide dividers on mobile */\n  .scl--web-component-round-icon-button-options-divider {\n    display: none;\n  }\n\n  /* Individual option item pill - icon only (116px = 3 per 350px row) */\n  .scl--web-component-round-icon-button-option-item { \n    padding: 10px 15px;\n    max-width: 116px;\n    min-height: 46px;\n    gap: 24px;\n    border-radius: 50px;\n    box-sizing: border-box;\n    flex: 0 0 116px;\n  }\n\n  /* Icon container */\n  .scl--web-component-round-icon-button-option-icon {\n    width: 43px;\n    height: 27px;\n  }\n\n  /* ==========================================\n     Icon + Label variant - 440px (min 2 items per row)\n     ========================================== */\n\n  .scl--web-component-round-icon-button-options-bar.has-labels {\n    width: 370px;\n    max-width: 370px;\n    height: auto;\n    padding: 10px 10px;\n    gap: 5px;\n    border-radius: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  /* Inner container - allows 2 items per row for icon+label */\n  .scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 0px;\n    gap: 10px 5px;\n    width: 370px;\n  }\n\n  /* Option item pill with label (165px = 2 per 340px row with 5px gap) */\n  .scl--web-component-round-icon-button-option-item.with-label {\n    padding: 12px 15px;\n    min-width: 165px;\n    max-width: 165px;\n    max-height: 50px;\n    border-radius: 50px;\n    box-sizing: border-box;\n    flex: 0 0 165px;\n  }\n\n  /* Icon + label row wrapper - 440px */\n  .scl--web-component-round-icon-button-option-icon-label {\n    gap: 9px;\n  }\n\n  /* Icon size in icon+label variant - 440px */\n  .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {\n    width: 26px;\n    height: 26px;\n  }\n\n  /* Label in icon+label variant - 440px */\n  .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {\n    font-size: 16px;\n    line-height: 16px;\n    white-space: nowrap;\n  }\n\n  /* ==========================================\n     Multi-row variant - 440px\n     ========================================== */\n\n  .scl--web-component-round-icon-button-options-bar.multi-row {\n    width: 370px;\n    max-width: 370px;\n    height: auto;\n    border-radius: 30px;\n  }\n\n  /* Icon + Label multi-row */\n  .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 350px;\n    gap: 10px 5px;\n  }\n\n  /* Flatten inner containers for has-labels multi-row (needs higher specificity) */\n  .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {\n    display: contents;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
